export default __webpack_public_path__ + "static/media/TasMapScreen.02f630a7.gif";